import { Typography } from '@material-ui/core';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import {
  TXTWCL_To_complete_the_sign_up_you_ne_ELL,
  TXTWCL_You_can_do_so_by_providing_a_v_ELL,
  TXTWCL_Your_details_have_been_savedX
} from './FR.messages.json';

const FR: React.FC = () => (
  <Typography>
    <Translation {...TXTWCL_Your_details_have_been_savedX} />{' '}
    <Translation values={{ 0: 30 }} {...TXTWCL_To_complete_the_sign_up_you_ne_ELL} />{' '}
    <Translation {...TXTWCL_You_can_do_so_by_providing_a_v_ELL} />
  </Typography>
);

export default FR;
